var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoBack = function SvgGoBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.71 5.002c.39.39.39 1.02 0 1.41l-.88.88H15c3.31 0 6 2.69 6 6s-2.69 6-6 6h-3c-.55 0-1-.45-1-1s.45-1 1-1h3c2.21 0 4-1.79 4-4s-1.79-4-4-4H6.83l.88.88a.996.996 0 1 1-1.41 1.41l-2.59-2.59a.996.996 0 0 1 0-1.41l2.59-2.59c.38-.38 1.02-.38 1.41.01"
  })));
};
export default SvgGoBack;